import React, { useEffect, useState } from 'react';
import { createPortal } from 'react-dom';

const SuccessOverlay = ({ message = 'Enregistré !', color = '#22c55e', visible, onDone }) => {
  const [phase, setPhase] = useState('in');

  useEffect(() => {
    if (!visible) return;
    setPhase('in');
    const outTimer = setTimeout(() => setPhase('out'), 1600);
    const doneTimer = setTimeout(() => { onDone?.(); }, 2100);
    return () => { clearTimeout(outTimer); clearTimeout(doneTimer); };
  }, [visible]);

  if (!visible) return null;

  return createPortal(
    <div
      className="fixed inset-0 z-[9999] flex items-center justify-center pointer-events-none"
      style={{ background: 'rgba(0,0,0,0.55)', backdropFilter: 'blur(4px)',
        animation: phase === 'in'
          ? 'success-fade-in 0.25s ease forwards'
          : 'success-fade-out 0.4s ease forwards' }}
    >
      <div className="flex flex-col items-center gap-4">
        <div style={{
          animation: 'circle-pop 0.4s cubic-bezier(0.34,1.56,0.64,1) forwards',
          width: 96, height: 96, borderRadius: '50%',
          background: color + '22',
          border: `3px solid ${color}`,
          display: 'flex', alignItems: 'center', justifyContent: 'center',
        }}>
          <svg width="48" height="48" viewBox="0 0 48 48" fill="none">
            <polyline
              points="10,26 20,36 38,14"
              stroke={color}
              strokeWidth="4"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeDasharray="60"
              style={{ animation: 'check-draw 0.35s ease 0.25s forwards', strokeDashoffset: 60 }}
            />
          </svg>
        </div>
        <p className="text-white font-black text-xl tracking-wide drop-shadow-lg" style={{ textShadow: `0 0 20px ${color}88` }}>
          {message}
        </p>
      </div>
    </div>,
    document.body
  );
};

export default SuccessOverlay;
